import { apiClient } from '../../lib/apiClient';
import type { TemplatePackRead } from '../../types/api';

/**
 * The pack registry — the niche layouts a post can start from. Global like
 * `/vibes` and `/slide-themes`: packs are deployment content, and a business
 * picks from them rather than authoring its own.
 */
export function listTemplatePacks(signal?: AbortSignal): Promise<TemplatePackRead[]> {
  return apiClient.get<TemplatePackRead[]>('/api/v1/template-packs', { signal });
}
